import React, { useState, useEffect, useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import {
  Card, CardHeader, CardContent, Grid, Button,
  Typography, Checkbox, Radio,
  AppBar, Grow, Paper,
  List, ListItem, Modal, Fade, Backdrop,
  Toolbar, FormLabel, FormControlLabel,
  Slider, FormHelperText, Divider, ListItemIcon, ListItemText, TextField, Collapse
} from '@material-ui/core'

import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'

import { withStyles, ThemeProvider } from '@material-ui/core/styles'

import { updateOrgUnitAdvancedInfo, getOrgUnitInfo, updateUnitCategoryExclusions, getUnitCategoryExclusions } from '../../../../redux/actions'
import { NotificationToast } from '../../tools/Toast'

import { SliderTheme } from '../../../../utils'

import log from 'loglevel'

const CustomSlider = withStyles({
  root: {
    height: '5px'
  },
  rail: {
    backgroundImage: 'linear-gradient(to right, rgba(82,145,252,1) 20%, rgba(78,23,154,1) 20% 40%, rgba(245,216,24,1) 40% 60%, rgba(231,132,15,1) 60% 80%, rgba(211,17,17,1) 80%)',
    height: '5px'
  },
  track: {
    // backgroundImage: 'linear-gradient(to right, rgba(82,145,252,1) 20%, rgba(78,23,154,1) 20% 40%, rgba(231,132,15,1) 40% 60%, rgba(245,216,24,1) 60% 80%, rgba(211,17,17,1) 80%)',
    height: '5px'
  },
  mark: {
    height: '5px',
    width: '5px',
    backgroundColor: '#fff'
  },
  markActive: {
    opacity: 1,
    backgroundColor: '#fff'
  }
})(Slider)

const GreenCheckbox = withStyles({
  root: {
    color: '#595959',
    '&$checked': {
      color: '#A4D164'
    }
  },
  checked: {}
})((props) => <Checkbox color='default' {...props} />)

const not = (a, b) => {
  return a.filter((value) => b.findIndex(x => x.categoryID === value.categoryID) === -1)
}

const intersection = (a, b) => {
  return a.filter((value) => b.findIndex(x => x.categoryID === value.categoryID) !== -1)
}

const union = (a, b) => {
  return [...a, ...not(b, a)]
}

const OrgUnitMgmtAdvanced = (props) => {
  const { unitName, newInfo, selectedKey, classes } = props

  const dispatch = useDispatch()
  const aupsList = useSelector(state => state.aups.aupList)
  const CategoryList = useSelector(state => state.orgUnits.categoryExclusions)
  // const aupIDName = aupsList.find(i => i.aupID === newInfo.assignedAUP)

  const marks = [
    { value: 20, label: '' },
    { value: 40, label: '' },
    { value: 60, label: '' },
    { value: 80, label: '' },
    { value: 100, label: '' }
  ]

  const [form, setForm] = useState({
    ignoreSeverity: 0,
    ignoreSeverityLevel: 1,
    alertOnCapture: 0,
    enableIcon: 1,
    aupEnabled: 0,
    enableWhitelistOnly: 0,
    enableWebLogging: 0,
    assignedAUP: null
  })
  const [open, setOpen] = useState(false)
  const [tableAUPOpen, setAUPOpen] = useState(newInfo.assignedAUP !== null)
  const [selectedValue, setSelectedValue] = useState(newInfo.assignedAUP)
  const [helperText, setHelperText] = useState('')
  const [enabledCategories, setEnabledCategories] = useState([])
  const [disabledCategories, setDisabledCategories] = useState([])
  const [checked, setChecked] = useState([])

  const [selectedAup, setSelectedAup] = useState({ aupName: '' })

  useMemo(() => { if (dispatch) { dispatch(getUnitCategoryExclusions()) } }, [dispatch])

  useMemo(() => {
    if (newInfo && Boolean(Object.keys(newInfo).length) && aupsList && Array.isArray(aupsList)) {
      const {
        ignoreSeverity: newIgnoreSeverity = 0, ignoreSeverityLevel: newIgnoreSeverityLevel = 1,
        alertOnCapture: newAlertOnCapture = 0, enableIcon: newEnableIcon = 1, aupEnabled: newAupEnabled = 0,
        enableWhitelistOnly: newEnableWhitelistIcon = 0, enableWebLogging: newEnableWebLogging = 0,
        assignedAUP: newAssignedAup = null
      } = newInfo

      const advancedInfo = {
        ignoreSeverity: newIgnoreSeverity,
        ignoreSeverityLevel: newIgnoreSeverityLevel,
        alertOnCapture: newAlertOnCapture,
        enableIcon: newEnableIcon,
        aupEnabled: newAupEnabled,
        enableWhitelistOnly: newEnableWhitelistIcon,
        enableWebLogging: newEnableWebLogging,
        assignedAUP: newAssignedAup
      }

      const aupInfo = aupsList.find((listInfo) => listInfo.aupID === newAssignedAup)
      if (aupInfo) { setSelectedAup(aupInfo) }

      setForm(advancedInfo)
    }
  }, [newInfo, aupsList])

  useEffect(() => {
    if (CategoryList && Array.isArray(CategoryList) && selectedKey) {
      // Finds the exclusions array within each category
      const { tempDisabled, tempEnabled } = CategoryList.reduce((obj, categoryInfo) => {
        if (categoryInfo && categoryInfo.exclusions && Boolean(categoryInfo.exclusions.length)) {
          const isDisabled = categoryInfo.exclusions.findIndex((x) => x === selectedKey) !== -1
          if (isDisabled) { obj.tempDisabled.push(categoryInfo) } else { obj.tempEnabled.push(categoryInfo) }
        } else {
          obj.tempEnabled.push(categoryInfo)
        }

        return obj
      }, { tempDisabled: [], tempEnabled: [] })

      // Once the category list has been searched it will set all of the exclusions for that unit as the 'disabled categories'
      setDisabledCategories(tempDisabled)

      // Now we set that new array to the 'enabled categories'
      setEnabledCategories(tempEnabled)
    }
  }, [CategoryList, selectedKey])

  const enabledChecked = intersection(checked, enabledCategories)
  const disabledChecked = intersection(checked, disabledCategories)

  const numberOfChecked = (items) => intersection(checked, items).length

  const handleCategoryToggle = (value) => {
    const index = checked.findIndex(x => x.categoryID === value.categoryID)
    const tempChecked = [...checked]
    if (index === -1) {
      tempChecked.push(value)
    } else {
      tempChecked.splice(index, 1)
    }
    setChecked(tempChecked)
  }

  const handleToggleAllCategories = (items) => {
    if (numberOfChecked(items) === items.length) {
      setChecked(not(checked, items))
    } else {
      setChecked(union(checked, items))
    }
  }

  const moveToDisabled = () => {
    setDisabledCategories(disabledCategories.concat(enabledChecked))
    setEnabledCategories(enabledCategories.filter(value => !checked.includes(value)))
    setChecked(not(checked, enabledChecked))
  }

  const moveToEnabled = () => {
    setEnabledCategories(enabledCategories.concat(disabledChecked))
    setDisabledCategories(disabledCategories.filter(value => !checked.includes(value)))
    setChecked(not(checked, disabledChecked))
  }

  const nameView = () => {
    if (selectedValue) {
      return (
        selectedAup.aupName
      )
    } else {
      return (
        form.assignedAUP
      )
    }
  }

  const handleSliderChange = (event, newValue) => {
    setForm({
      ...form,
      ignoreSeverityLevel: newValue
    })
  }

  const handleSaveSelection = () => {
    if (!selectedValue) {
      setHelperText('You Must Select a Message.')
    } else if (selectedValue) {
      setForm({
        ...form,
        assignedAUP: selectedValue
      })

      if (aupsList && Array.isArray(aupsList)) {
        const aupInfo = aupsList.find((i) => i.aupID === selectedValue)
        if (aupInfo) { setSelectedAup(aupInfo) }
      }

      setHelperText('')
      setOpen(false)
      setAUPOpen(true)
    }
  }

  const cancelAUPSelection = () => {
    if (form.assignedAUP === null) {
      form.aupEnabled = 0
      setOpen(false)
    } else {
      setOpen(false)
    }
  }

  const handleSeverityToggle = () => {
    if (form.ignoreSeverity === 0) {
      setForm({
        ...form,
        ignoreSeverity: 1
      })
    } else {
      setForm({
        ...form,
        ignoreSeverity: 0
      })
    }
  }

  const handleAUPToggle = () => {
    if (form.aupEnabled === 0) {
      setOpen(true)
      setForm({
        ...form,
        aupEnabled: 1
      })
    } else {
      setForm({
        ...form,
        aupEnabled: 0
      })
    }
    if (tableAUPOpen) {
      setAUPOpen((prev) => !prev)
    }
  }

  const handleToggle = (e) => {
    const newForm = { ...form }
    const toggle = e
    if (toggle === 'alerts') {
      if (form.alertOnCapture === 0) {
        newForm.alertOnCapture = 1
        setForm(newForm)
      } else if (form.alertOnCapture === 1) {
        newForm.alertOnCapture = 0
        setForm(newForm)
      }
    } else if (toggle === 'icon') {
      if (form.enableIcon === 0) {
        newForm.enableIcon = 1
        setForm(newForm)
      } else if (form.enableIcon === 1) {
        newForm.enableIcon = 0
        setForm(newForm)
      }
    } else if (toggle === 'whitelist') {
      if (form.enableWhitelistOnly === 0) {
        newForm.enableWhitelistOnly = 1
        setForm(newForm)
      } else if (form.enableWhitelistOnly === 1) {
        newForm.enableWhitelistOnly = 0
        setForm(newForm)
      }
    } else if (toggle === 'weblog') {
      if (form.enableWebLogging === 0) {
        newForm.enableWebLogging = 1
        setForm(newForm)
      } else if (form.enableWebLogging === 1) {
        newForm.enableWebLogging = 0
        setForm(newForm)
      }
    }
  }

  const handleSubmit = () => {
    const categoriesToAdd = []
    const categoriesToDelete = []
    if (enabledCategories && enabledCategories.length) {
      enabledCategories.forEach(category => categoriesToDelete.push(category.categoryID))
    }
    if (disabledCategories && disabledCategories.length) {
      disabledCategories.forEach(category => categoriesToAdd.push(category.categoryID))
    }

    const unitID = selectedKey

    const advancedInfo = {
      ...newInfo,
      ignoreSeverity: form.ignoreSeverity,
      ignoreSeverityLevel: form.ignoreSeverityLevel,
      alertOnCapture: form.alertOnCapture,
      enableIcon: form.enableIcon,
      aupEnabled: form.aupEnabled,
      enableWhitelistOnly: form.enableWhitelistOnly,
      enableWebLogging: form.enableWebLogging,
      assignedAUP: form.assignedAUP
    }

    const categoryInfo = {
      unitID: unitID,
      categoriesToAdd: categoriesToAdd,
      categoriesToDelete: categoriesToDelete
    }

    dispatch(updateUnitCategoryExclusions(categoryInfo, fireUpdateCategoriesSuccess, fireUpdateCategoriesFailure))
    dispatch(updateOrgUnitAdvancedInfo(advancedInfo, unitID, fireSuccess, fireFailure))
    log.debug(advancedInfo)
  }

  const fireSuccess = () => {
    NotificationToast(false, 'Advanced Settings updated successfully!')
    dispatch(getOrgUnitInfo(selectedKey))
  }

  const fireFailure = () => {
    NotificationToast(true, 'Failed to update Advanced Settings.')
  }

  const fireUpdateCategoriesSuccess = () => {
    // console.log('categories updated successfully')
  }

  const fireUpdateCategoriesFailure = () => {
    // console.log('category update failure')
  }

  // const handleBackTrack = (tab) => {
  //   const changesMade = (
  //     (form.ignoreSeverity !== advancedSettingsForm.ignoreSeverity) || (form.ignoreSeverityLevel !== advancedSettingsForm.ignoreSeverityLevel) ||
  //     (form.alertOnCapture !== advancedSettingsForm.alertOnCapture) || (form.enableIcon !== advancedSettingsForm.enableIcon) ||
  //     (form.aupEnabled !== advancedSettingsForm.aupEnabled) || (form.enableWhitelistOnly !== advancedSettingsForm.enableWhitelistOnly) ||
  //     (form.enableWebLogging !== advancedSettingsForm.enableWebLogging) || (form.assignedAUP !== advancedSettingsForm.assignedAUP)
  //   )

  //   onBackTrack(changesMade, tab)
  // }

  // Example of category object:
  //  { accountID: null
  //  categoryDesc: ''
  //  categoryID: ''
  //  categoryName: ''}

  const customList = (listName, values) => {
    return (
      <Card style={{ maxHeight: '20em', overflow: 'scroll', height: values.length ? '' : '20em' }}>
        <CardHeader
          title={
            <Typography
              variant='body1'
              className='my-auto'
              style={{
                textTransform: 'none',
                fontWeight: 'bold',
                textAlign: 'center',
                color: listName === 'Enabled' ? '#007BFF' : '#666666'
              }}
            >
              {listName}
            </Typography>
          }
          style={{ padding: '5px' }}
        />
        <Divider />
        <List>
          <ListItem button onClick={() => handleToggleAllCategories(values)} style={{ padding: 0 }}>
            <ListItemIcon style={{ minWidth: '40px' }}>
              <GreenCheckbox
                size='small'
                disabled={values.length === 0}
                checked={listName === 'Enabled' ? enabledChecked.length === values.length && values.length !== 0 : disabledChecked.length === values.length && values.length !== 0}
              />
            </ListItemIcon>
            <ListItemText
              primary={
                <Typography variant='caption' className='text-muted' style={{ fontWeight: 'bold' }}>Select All</Typography>
              }
            />
          </ListItem>
          <Divider variant='middle' />
          {values.length
            ? (
              values.map((item, index) => {
                return (
                  <ListItem key={`category-${index}-id-${item.categoryID}`} button onClick={() => handleCategoryToggle(item)} style={{ padding: 0 }}>
                    <ListItemIcon style={{ minWidth: '40px' }}>
                      <GreenCheckbox size='small' checked={checked.findIndex(x => x.categoryID === item.categoryID) !== -1} />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <Typography variant='caption' style={{ textTransform: 'capitalize' }}>{item.categoryName.toLowerCase()}</Typography>
                      }
                    />
                  </ListItem>
                )
              })
            )
            : (
              <ListItem>
                <Typography
                  variant='caption'
                  className='text-muted my-auto'
                  style={{ textTransform: 'none', textAlign: 'center' }}
                >
                  {`No categories ${listName === 'Enabled' ? 'enabled' : 'disabled'}.`}
                </Typography>
              </ListItem>
            )}
        </List>
      </Card>
    )
  }

  const AupListItem = (props) => {
    const { list } = props
    const [aupViewOpen, setAupViewOpen] = useState(false)

    return (
      <ListItem role={undefined} dense>
        <Grid container direction='column'>
          <Grid container item direction='row' alignContent='center' justify='space-between'>
            <FormControlLabel
              control={
                <Radio
                  checked={selectedValue === list.aupID}
                  onChange={() => setSelectedValue(list.aupID)}
                  value={list.aupName}
                  name={list.aupName}
                  inputProps={{ 'aria-label': list.aupName }}
                  classes={{ root: classes.radioButton, checked: classes.checked }}
                />
              }
              label={list.aupName}
              labelPlacement='end'
            />
            <Button variant='contained' size='small' className={`my-auto ${classes.aupSaveButton}`} onClick={() => setAupViewOpen((prev) => !prev)}>View</Button>
          </Grid>
          <Grid container item xs={12}>
            <Collapse in={aupViewOpen} style={{ width: '100%' }}>
              <Paper style={{ maxHeight: '12em', overflowY: 'scroll', width: '100% !important', padding: '1em' }}>
                <TextField
                  fullWidth
                  multiline
                  value={list.aupText}
                />
              </Paper>
            </Collapse>
          </Grid>
        </Grid>
      </ListItem>
    )
  }

  return (
    <CardContent className='mt-2 mx-2'>
      <Grid item container direction='row' className='mt-4'>
        <Grid item container direction='column' sm={12} className='pl-0'>
          <h2 className='font-weight-bold mb-2' style={{ fontSize: '1.5rem', color: '#007bff' }}>Advanced Options for {unitName}</h2>
        </Grid>
      </Grid>
      <Grid item container direction='row'>
        <Card className='mb-2 w-100 p-2'>
          <Grid item container direction='column' xs={12}>
            <Grid item container direction='row'>
              <FormLabel className='font-weight-bold mt-2 mb-0'> Enable Stealth Mode</FormLabel>
            </Grid>
            <Grid item container direction='row'>
              <Typography variant='subtitle2' className='text-muted my-auto' style={{ textTransform: 'none' }}>
                Enables notification alerts when new captures are detected.
              </Typography>
              <GreenCheckbox
                className='float-right'
                value='alerts'
                onChange={(e) => handleToggle(e.target.value)}
                checked={!form.alertOnCapture}
              />
            </Grid>
          </Grid>
        </Card>
        <Grid item container direction='row'>
          <Card className='mb-2 w-100 p-2'>
            <Grid item container direction='column' xs={12}>
              <Grid item container direction='row'>
                <FormLabel className='font-weight-bold mt-2 mb-0'>Enable LearnSafe Icon</FormLabel>
              </Grid>
              <Grid item container direction='row'>
                <Typography variant='subtitle2' className='text-muted my-auto' style={{ textTransform: 'none' }}>
                  Determines if the LearnSafe icon shows in the system tray.
                </Typography>
                <GreenCheckbox
                  className='float-right'
                  value='icon'
                  onChange={(e) => handleToggle(e.target.value)}
                  checked={!!form.enableIcon}
                />
              </Grid>
            </Grid>
          </Card>
        </Grid>
        <Grid item container direction='row'>
          <Card className='mb-2 w-100 p-2'>
            <Grid item container direction='column' xs={12}>
              <Grid item container direction='row'>
                <FormLabel className='font-weight-bold mt-2 mb-0'>AUP Enabled</FormLabel>
              </Grid>
              <Grid item container direction='row'>
                <Typography variant='subtitle2' className='text-muted my-auto' style={{ textTransform: 'none' }}>
                  Enable the AUP when the agent first launches
                </Typography>
                <GreenCheckbox
                  className='float-right'
                  value='aup'
                  onChange={handleAUPToggle}
                  checked={!!form.aupEnabled}
                />
              </Grid>
              <Grow in={tableAUPOpen} timeout={500} unmountOnExit>
                <Grid item container direction='column'>
                  <Grid item xs={9}>
                    <Typography variant='overline' style={{ textTransform: 'none', color: '#007bff' }}>
                      <Typography style={{ color: '#595959' }}>Selected:</Typography>
                      {nameView()}
                    </Typography>
                    <Grid item>
                      <Button size='small' className={classes.changeButton} onClick={() => setOpen(true)}>Change</Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grow>
              <Modal
                aria-labelledby='transition-modal-title'
                aria-describedby='transition-modal-description'
                className={classes.modal}
                open={open}
                onClose={() => setOpen(false)}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                  timeout: 500
                }}
              >
                <Fade in={open}>
                  <Paper style={{ overflowY: 'scroll', maxHeight: '90%' }}>
                    <AppBar position='relative' className={classes.modalAppBar}>
                      <Toolbar>
                        <Typography variant='h6' component='h6'>
                          Please Choose an AUP Message
                        </Typography>
                      </Toolbar>
                    </AppBar>
                    <Grid container justify='center' direction='column' className={classes.modalContainer}>
                      <Grid container item direction='row' justify='center' className='h-100'>
                        <Grid item xs={12}>
                          <List className={classes.root}>
                            {/* import AUP messages */}
                            {aupsList.map((list) => {
                              return (
                                <AupListItem key={`aup- ${list.aupID}`} list={list} />
                              )
                            })}
                            <FormHelperText className={classes.helperTextLine}>{helperText}</FormHelperText>
                          </List>
                        </Grid>
                        <Button
                          className='mt-3 save-button'
                          onClick={cancelAUPSelection}
                        >
                          Cancel
                        </Button>
                        <Button
                          className={`mt-3 ml-2 save-button ${classes.saveButton}`}
                          onClick={handleSaveSelection}
                        >
                          Save
                        </Button>
                      </Grid>
                    </Grid>
                  </Paper>
                </Fade>
              </Modal>
            </Grid>
          </Card>
        </Grid>
        <Grid item container direction='row'>
          <Card className='mb-2 w-100 p-2'>
            <Grid item container direction='column' xs={12}>
              <Grid item container direction='row'>
                <FormLabel className='font-weight-bold mt-2 mb-0'>'Not A Problem' Severity</FormLabel>
              </Grid>
              <Grid item container direction='row'>
                <Typography variant='subtitle2' className='text-muted my-auto' style={{ textTransform: 'none' }}>
                  If enabled, captures below the selected number will be set to 'Not A Problem'.
                </Typography>
                <GreenCheckbox
                  className='loat-right'
                  value='severity'
                  onChange={handleSeverityToggle}
                  checked={!!form.ignoreSeverity}
                // inputProps={{ 'aria-label': 'Switch Severity' }}
                />
              </Grid>
              <Grow in={form.ignoreSeverity === 1} timeout={500} unmountOnExit>
                <Grid item container direction='row' justify='center'>
                  <ThemeProvider theme={SliderTheme(form.ignoreSeverityLevel === 0 ? 1 : form.ignoreSeverityLevel)}>
                    <Grid item xs={9}>
                      <CustomSlider
                        className='mt-5'
                        value={parseInt(form.ignoreSeverityLevel, 10)}
                        onChange={handleSliderChange}
                        aria-labelledby='discrete-slider-always'
                        min={1}
                        max={100}
                        marks={marks}
                        valueLabelDisplay='on'
                      // track='inverted'
                      />
                    </Grid>
                  </ThemeProvider>
                </Grid>
              </Grow>
            </Grid>
          </Card>
        </Grid>
        {/* The following card has been temporarily hidden as of 8-3-2020 as part of LG-465 but may be reenstated later  */}
        {/* <Grid item xs={12}>
            <Card className='mb-2'>
              <Col>
                <Label className='font-weight-bold mt-2 mb-0'>Enable WhiteList Sites Only</Label>
                <Typography variant='subtitle2' className='text-muted' style={{ textTransform: 'none' }}>
                  Blocks all websites except ones in the whitelist.
                </Typography>
                <GreenCheckbox
                  className='ml-3 mt-1 float-right'
                  value='whitelist'
                  onChange={(e) => handleToggle(e.target.value)}
                  checked={!!form.enableWhitelistOnly}
                />
              </Col>
            </Card>
          </Grid> */}
        <Grid item container direction='row'>
          <Card className='mb-2 w-100 p-2'>
            <Grid item container direction='column' xs={12}>
              <Grid item container direction='row'>
                <FormLabel className='font-weight-bold mt-2 mb-0'>Enable Web Logging</FormLabel>
              </Grid>
              <Grid item container direction='row'>
                <Typography variant='subtitle2' className='text-muted my-auto' style={{ textTransform: 'none' }}>
                  Log all web requests.
                </Typography>
                <GreenCheckbox
                  className='float-right'
                  value='weblog'
                  onChange={(e) => handleToggle(e.target.value)}
                  checked={!!form.enableWebLogging}
                />
              </Grid>
            </Grid>
          </Card>
        </Grid>
        <Grid item container direction='row'>
          <Card className='mb-2 w-100 p-2'>
            <Grid item container direction='column' xs={12}>
              <Grid item container direction='row'>
                <FormLabel className='font-weight-bold mt-2 mb-0'>Enable/Disable Categories</FormLabel>
              </Grid>
              <Grid item container direction='row'>
                <Typography variant='subtitle2' className='text-muted my-auto' style={{ textTransform: 'none' }}>Choose categories to no longer monitor, or to renable monitoring for this unit.</Typography>
              </Grid>
              <Grid item container direction='row' justify='center' style={{ marginTop: '1em' }}>
                <Grid item xs={4}>
                  {customList('Enabled', enabledCategories)}
                </Grid>
                <Grid item container direction='column' xs={3} justify='center' alignItems='center' className='mx-1'>
                  <Button
                    variant='contained'
                    onClick={moveToEnabled}
                    classes={{ root: classes.categoryEnableBtn, label: classes.categoryButtonLabel }}
                    disabled={disabledChecked.length === 0}
                    startIcon={<ChevronLeftIcon />}
                  >
                    Enable Selected
                  </Button>
                  <Button
                    variant='contained'
                    onClick={moveToDisabled}
                    disabled={enabledChecked.length === 0}
                    classes={{ root: classes.categoryDisableBtn, label: classes.categoryButtonLabel }}
                    endIcon={<ChevronRightIcon />}
                  >
                    Disable Selected
                  </Button>
                </Grid>
                <Grid item xs={4}>
                  {customList('Disabled', disabledCategories)}
                </Grid>
              </Grid>
            </Grid>
          </Card>
        </Grid>
      </Grid>
      <Grid item container direction='column' sm={12}>
        <Grid item container direction='row' className='justify-content-end'>
          <Button className={`mt-3 ${classes.saveButton}`} variant='contained' onClick={handleSubmit}>Save</Button>
        </Grid>
      </Grid>
    </CardContent>
  )
}

export default OrgUnitMgmtAdvanced
